import { DeclarationPropertyValueData } from "./declarationPropertyValueData";
import { DeclarationPropertiesTypes } from "./enums/declarationPropertiesTypes";
import { DeclarationPropertiesViews } from "./enums/declarationPropertiesViews";
import { RequestsStates } from "./enums/requestsStates";
import { CatalogOperationTypes } from "./enums/catalogOperationTypes";
import { DateType, Dictionary } from "./types/index";

/**
 * Класс для формирования запроса с данными операции на сервер.
 */
export class OperationRequestData {
  /**
   * Код операции в каталоге.
   */
  public respondentCode: string = "";

  /**
   * ИД операции.
   */
  public operationId: number = 0;

  /**
   * ИД шаблона.
   */
  public templateId: number = 0;

  /**
   * Имя шаблона.
   */
  public templateName: string = "";

  /**
   * Имя изменяемого реквизита.
   */
  public assignProperty: string = "";

  /**
   * Код верификации.
   */
  public verificationCode: string = "";

  /**
   * Признак необходимости подтверждения.
   */
  public needConfirm: boolean = false;

  /**
   * Признак необходимости отображения информации перед проведением.
   */
  public needInfoBeforeExecute: boolean = false;

  /**
   * Статус запроса.
   */
  public requestState: RequestsStates = RequestsStates.None;

  public RequestStateRem: string = '';

  public serverErrorRequestState: RequestsStates = RequestsStates.None;

  /**
   * Статус запроса.
   */
  public requestStateDescription: string = "";

  /**
   * Описание операции.
   */
  public description: string = "";

  /**
   * Заголовок.
   */
  public caption: string = "";

  /**
   * Клиентское время.
   */
  public clientTime: DateType = new Date();

  /**
   * Ссылка на картинку.
   */
  public picture: string = "";

  /**
   * Ссылка на картинку.
   */
  public bigImage: string = "";

  /**
   * Список ключей.
   */
  public keys: Array<string> = [];

  /**
   * Список значений.
   */
  public values: Array<string> = [];

  /**
   * Список типов.
   */
  public types: Array<string> = [];

  /**
   * Список типов.
   */
  public imageProps: Array<string> = [];

  /**
   * Коллекция изменения состояния видимости реквизитов.
   */
  public views: Dictionary<DeclarationPropertiesViews> = {};

  /**
   * Коллекция изменения состояния видимости реквизитов.
   */
  public PrepareData: Dictionary<string> = {};

  /**
 * Коллекция изменения фильтров счетов.
 */
  public filters: Dictionary<number> = {};

  /**
   * Коллекция ошибок с сервера
   */
  public PropertyErrors: Dictionary<string> = {};

  /**
   * Коллекция ошибок с сервера
   */
  public Captions: Dictionary<string> = {};

  /**
   * Список дефолтовых состояний списков.
   */
  public listDefaults: Dictionary<string> = {};

  /**
  * Заполнение списков 
  */
  public listValues: Dictionary<Array<DeclarationPropertyValueData>> = {};

  /**
   * Коллекция детализации по реквизитам операции.
   */
  public details: Array<DeclarationPropertyValueData> = [];

  /**
  * Изменения описания полей.
  */
  public assignDescription: Dictionary<string> = {};

  public isRespondentActive: boolean = false;

  public isRespondentDirect: boolean = false;

  public contractRef: string = '';

  /**
   * Сообщение.
   */
  public message: string = "";

  /**
    * Свободные данные
  */
  public listObjects: any = null;

  public typeSource: number = 0;

  public sbpID: string | null = null;

  public NeedAcceptUri: string = '';

  public NeedAcceptMessage: string = '';

  public NeedAcceptProperty: string = '';

  public DocumentFiles: Array<any> = [];

  /**
   * Тип операции для проверки настроек сбп
  */
  public operationType: CatalogOperationTypes = CatalogOperationTypes.Any;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      if (src.Data?.Properties?.type) {
        this.operationType = (src.Data?.Properties?.type ?? '') as CatalogOperationTypes;
      }
      const si = src.SystemInfo;

      this.operationId = si.OperationId ?? 0;

      this.respondentCode = src.Name ?? ""; // В запросе GetTemplate.

      const sip = si.Data.Properties;
      this.templateId = sip.templateId ?? 0;

      this.needInfoBeforeExecute = sip.OperationInfoExt ?? false; // В ответе на Prepare

      this.NeedAcceptUri = sip.NeedAcceptUri ?? '';
      this.NeedAcceptMessage = sip.NeedAcceptMessage ?? '';
      this.NeedAcceptProperty = sip.NeedAcceptProperty ?? '';

      if (sip.Confirm != undefined) this.needConfirm = sip.Confirm ?? false;
      // В ответе на SaveTemplate
      else this.needConfirm = !(sip.NotConfirm ?? false); // В ответе на Prepare

      this.description = sip.description ?? "";

      this.typeSource = sip.typeSource ?? 0;

      this.message = sip.message ?? "";

      this.sbpID = src.Data?.Properties?.sbpID ?? null;

      const jHead =
        si.Data?.InnerData?.Data?.VerificationData?.InnerData?.Data?.Header
          ?.Properties;
      this.caption = jHead?.Caption ?? "";

      if (this.caption.trim() === "") {
        this.caption = sip.Caption ?? "";
      }

      this.isRespondentActive = src.Data?.Properties.IsRespondentActive;
      this.isRespondentDirect = src.Data?.Properties.IsRespondentDirect;

      this.contractRef = src.Data?.Properties.contract;

      this.picture = sip.Picture ?? "";
      this.bigImage = sip.BigImage ?? "";

      this.requestState = (si.State ?? 0) as RequestsStates;
      this.RequestStateRem = src.Data?.Properties.RequestStateRem ?? '';
      this.serverErrorRequestState = (src.Data?.Properties?.RequestState ?? 0) as RequestsStates;
      this.requestStateDescription = si.Description ?? "";
      const props = src.Data?.Properties;
      // Грузим без типов.
      for (const key in props) {
        this.keys.push(key);
        this.values.push(props[key] != null ? props[key].toString() : "");
      }

      // Данные по изменению видимости реквизитов.
      const views = src.Data?.InnerData?.Data?.views?.Properties;
      if (views) {
        for (const key in views) {
          this.views[key] = (views[key] ?? 0) as DeclarationPropertiesViews;
        }
      }

      const prepareData = src.Data?.InnerData?.Data?.PrepareData?.Properties;
      if (prepareData) {
        for (const key in prepareData) {
          if (prepareData[key] == null)
            this.PrepareData['messageAfterTariff'] = key;
          else
            this.PrepareData[key] = prepareData[key];
        }
      }

      // Данные по изменению видимости реквизитов.
      const filters = src.Data?.InnerData?.Data?.filters?.Properties;
      if (filters) {
        for (const key in filters) {
          this.filters[key] = filters[key] ?? 0;
        }
      }

      // Данные по изменению видимости реквизитов.
      const imageProps = src.Data?.InnerData?.Data?.imageProps?.Properties;
      if (imageProps) {
        for (const key in imageProps) {
          this.imageProps[key] = imageProps[key] ?? "";
        }
      }

      // Данные по ошибкам полей с сервера
      const propertyErrors = si.Data?.InnerData?.Data?.errors?.Properties;
      if (propertyErrors) {
        for (const key in propertyErrors) {
          //this.keys.push(key);
          this.PropertyErrors[key] = propertyErrors[key] ?? '';
        }
      }

      const capts = src.Data?.InnerData?.Data?.captions?.Properties;
      if (capts) {
        for (const key in capts) {
          //this.keys.push(key);
          this.Captions[key] = capts[key] ?? '';
        }
      }
      // Заполнение списков
      const listValues = si.Data?.InnerData?.Data?.listValues?.InnerData?.Data;
      if (listValues) {
        for (const key in listValues) {
          // this.keys.push(key);
          const listValsArr: Array<DeclarationPropertyValueData> = []

          for (const i in listValues[key].Properties)
            listValsArr.push(new DeclarationPropertyValueData(i, listValues[key].Properties[i]));

          this.listValues[key] = listValsArr;
        }
      }
      // Детализация по реквизитам операции.
      const details = si.Data?.InnerData?.Data?.VerificationData?.Properties;
      if (details != null) {
        for (const key in details) {
          this.details.push(
            new DeclarationPropertyValueData(key, details[key])
          );
        }
      }

      const assignDescription = src.Data?.InnerData?.Data?.description?.Properties;
      if (assignDescription != null) {
        for (const key in assignDescription) {
          this.assignDescription[key] = assignDescription[key] ?? "";
        }
      }

      const listDefaults = src.Data?.InnerData?.Data?.listDefaults?.Properties;
      if (listDefaults != null) {
        for (const key in listDefaults) {
          this.listDefaults[key] = listDefaults[key] ?? "";
        }
      }

      const listObjects = src.Data?.InnerData?.Data;
      if (listObjects)
        this.listObjects = listObjects;

      const documentFiles: any = si.Data.InnerData?.Data?.DocumentFiles?.InnerData?.Data;
      if (documentFiles) {
        for (const file in documentFiles) {
          if (documentFiles[file]) {
            this.DocumentFiles.push(documentFiles[file].Properties);
          }
        }
      }
        
    }
  }

  /**
   * Получение значения реквизита.
   * @param key Ключ.
   * @returns Значение.
   */
  public getPropertyValue(key: string): string {
    const iKey = this.keys.indexOf(key);
    return iKey >= 0 ? this.values[iKey] : "";
  }

  /**
   * Установка реквизита.
   * @param key Ключ.
   * @param value Значение.
   * @param type Тип.
   */
  public setProperty(
    key: string,
    value: any,
    type: DeclarationPropertiesTypes
  ): void {
    if (key.trim() === "") return;

    const iKey = this.keys.indexOf(key);
    if (iKey >= 0) {
      this.values[iKey] = value;
      this.types[iKey] = this.PropertyTypeToString(type);
    } else {
      this.keys.push(key);
      this.values.push(value);
      this.types.push(this.PropertyTypeToString(type));
    }
  }

  /**
   * Конвертация из перечисления типа реквизита декларации в текстовый тип запроса.
   * @param type Вариант перечисления.
   * @returns Текстовый тип.
   */
  public PropertyTypeToString(type: DeclarationPropertiesTypes): string {
    let sType: string = "";
    switch (type) {
      case DeclarationPropertiesTypes.Int:
        sType = "Int";
        break;
      case DeclarationPropertiesTypes.Decimal:
        sType = "Decimal";
        break;
      case DeclarationPropertiesTypes.DateTime:
        sType = "DateTime";
        break;
      case DeclarationPropertiesTypes.Boolean:
        sType = "Boolean";
        break;
      case DeclarationPropertiesTypes.UserAccount:
        sType = "String";
        break;
      case DeclarationPropertiesTypes.File:
        sType = "File";
        break;
      case DeclarationPropertiesTypes.ObjectsList:
        sType = "ObjectsList";
        break;
      default:
        sType = "String";
        break;
    }
    return sType;
  }
}
